import React from "react";
import { FormDatePickerProps, FormDatePickerBase } from "./DatePickerBase";
import { usePrevious } from "utilities";
import moment from "moment";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

interface OptionalDatePickerProps extends Omit<FormDatePickerProps, "value" | "onChange"> {
  value: moment.Moment | null
  onChange: (value: moment.Moment | null, fromCalendar: boolean) => void;
  initialDateAfterToggleOn?: moment.Moment
}

export const OptionalDatePicker = (props: OptionalDatePickerProps) => {
  const { initialDateAfterToggleOn, value, onChange, ...rest } = props;
  const previousValue = usePrevious(value);

  const onDisplayChecked = (checked: boolean) => {
    if (checked) {
      if (previousValue == null) {
        onChange(initialDateAfterToggleOn ?? moment.utc().startOf("day"), false);
      } else {
        onChange(previousValue, false);
      }
    } else {
      onChange(null, false);
    }
  };

  return <div className="flex gap-small">
    <div>
      <Checkbox
        checked={value != null}
        onChange={(_, checked) => { onDisplayChecked(checked); }}
      />
    </div>

    {(value != null) && <div>
      <FormDatePickerBase
        mode="single"
        value={value}
        onChange={onChange}
        {...rest}
      />
    </div>}
  </div>;
}